import { render, staticRenderFns } from "./SearchIcon.vue?vue&type=template&id=8d521dd4&scoped=true&"
import script from "./SearchIcon.vue?vue&type=script&lang=js&"
export * from "./SearchIcon.vue?vue&type=script&lang=js&"
import style0 from "./SearchIcon.vue?vue&type=style&index=0&id=8d521dd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d521dd4",
  null
  
)

export default component.exports